export const FACEBOOK = 'facebook';
export const GOOGLE = 'google';
export const YELP = 'yelp';
